<template>
    <div class="components-container">
        <!-- 考试信息查询 -->
        <div :title="examForm.examName" class="examInfoDialog" width="70%" top="12vh" :visible.sync="examInfoDialogVisible" @closed="closeExamInfoDialog" append-to-body>
            <div class="examInfoDiv">
                <table class="timetable" v-loading="timetableLoading" width="100%" element-loading-text="课表加载中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
                    <tr>
                        <td class="timetableTitle" colspan="2"></td>
                        <td class="timetableTitle" v-for="(item, index) in weekDayName" height="60px">{{ item }}</td>
                    </tr>
                    <tr v-if="forenoonNum > 0">
                        <td class="timetableTitle" :rowspan="forenoonNum" style="width:3%;"><span>上<br /><br />午</span></td>
                        <td class="timetableTitle" style="width:15%" :height="timetdHeight">{{ timeQuantum[0] }}</td>
                        <td v-for="m in weekDayNum" :id="'cell_' + (m-1)" :style="{width: 81/weekDayNum + '%'}" class="cellsize">
                        </td>
                    </tr>
                    <template v-if="forenoonNum > 1">
                        <tr v-for="n in forenoonNum-1">
                            <td :class="n < forenoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'" :height="timetdHeight">{{ timeQuantum[n] }}</td>
                            <td :class="n < forenoonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum"
                                :id="'cell_' + (n*weekDayNum + m-1)" class="cellsize"></td>
                        </tr>
                    </template>
                    <tr v-if="noonNum > 0">
                        <td class="timetableTitle" :rowspan="noonNum"><span>中<br /><br />午</span></td>
                        <td class="timetableTitle" :height="timetdHeight">{{ timeQuantum[forenoonNum] }}</td>
                        <td v-for="m in weekDayNum" :id="'cell_' + (forenoonNum*weekDayNum + m-1)" :style="{width: 81/weekDayNum + '%'}" class="cellsize"></td>
                    </tr>
                    <template v-if="noonNum > 1">
                        <tr v-for="n in noonNum-1">
                            <td :class="n < noonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'" :height="timetdHeight">
                                {{ timeQuantum[forenoonNum+n] }}
                            </td>
                            <td :class="n < noonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum"
                                :id="'cell_' + (forenoonNum*weekDayNum + n*weekDayNum + m-1)" class="cellsize"></td>
                        </tr>
                    </template>
                    <tr v-if="afternoonNum > 0">
                        <td class="timetableTitle" :rowspan="afternoonNum"><span>下<br /><br />午</span></td>
                        <td class="timetableTitle" :height="timetdHeight">{{ timeQuantum[forenoonNum+noonNum] }}</td>
                        <td v-for="m in weekDayNum" :style="{width: 81/weekDayNum + '%'}" class="cellsize"
                            :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + m-1)">
                        </td>
                    </tr>
                    <template v-if="afternoonNum > 1">
                        <tr v-for="n in afternoonNum-1">
                            <td :class="n < afternoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'" :height="timetdHeight">{{ timeQuantum[forenoonNum+noonNum+n] }}</td>
                            <td :class="n < afternoonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum" class="cellsize"
                                :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + n*weekDayNum + m-1)">
                            </td>
                        </tr>
                    </template>
                    <tr v-if="eveningNum > 0">
                        <td class="timetableTitle" :rowspan="eveningNum"><span>晚<br /><br />上</span></td>
                        <td class="timetableTitle" :height="timetdHeight">{{ timeQuantum[forenoonNum+noonNum+afternoonNum] }}</td>
                        <td v-for="m in weekDayNum" :style="{width: 81/weekDayNum + '%'}" class="cellsize"
                            :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + m-1)">
                        </td>
                    </tr>
                    <template v-if="eveningNum > 1">
                        <tr v-for="n in eveningNum-1">
                            <td class="timetableTitle" :height="timetdHeight">{{ timeQuantum[forenoonNum+noonNum+afternoonNum+n] }}</td>
                            <td v-for="m in weekDayNum" class="cellsize"
                                :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + n*weekDayNum + m-1)">
                            </td>
                        </tr>
                    </template>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import { confirmMsg } from "utils/message";

    export default {
        props:{
            transXnxqbm: {type: String,default () {return null;} },
            transKcapzbbh: {type: String,default () {return null;} },
            transExamName: {type: String,default () {return null;} },
            transExamType: {type: String,default () {return null;} },
            transClassCode: {type: String,default () {return null;} },
            transTeacherCode: {type: String,default () {return null;} },
            transSearchType: {type: String,default () {return null;} },
            transUserAuth: {type: String,default () {return null;} },
        },
        data() {
            return {
                examForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: null,
                    examName: null,
                    searchType: null,
                    teacherName: null,
                    kcapzbbh: null,
                    examType: null,
                    classCode: null,
                    teacherCode: null,
                },
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                xnxqInfo: [], //学年学期下拉框
                courseTypeInfo: [], //课程类型下拉框
                courseInfo: [], //课程下拉框
                classInfo: [],//班级下拉框
                stateInfo: [],//状态下拉框
                majorInfo: [],//专业下拉框
                gradeInfo: [],//年级下拉框
                tableData: [],
                currentXnxq: null,//当前学期
                checkSelection: false,//是否在选课时间范围内
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: null,
                mainTableHeight: 500,
                dialogTitle: "",
                dialogVisible: false,
                formSubmiting: false,
                editType: null,
                searchTypeInfo: [],
                examInfoDialogVisible: true,
                userAuth: null,
                timetdHeight: 100,

                //课表基本参数
                weekDayNum: null,
                weekDayName: null,
                forenoonNum: null,
                noonNum: null,
                afternoonNum: null,
                eveningNum: null,
                timeQuantum: [],
                weekInfo: [],
                //课表内容
                timetableInfo: null,
                cellContent: [],
                timetableLoading: false,
            };
        },
        created() {
            this.examForm.xnxqbm = this.transXnxqbm;
            this.examForm.kcapzbbh = this.transKcapzbbh;
            this.examForm.examName = this.transExamName;
            this.examForm.examType = this.transExamType;
            this.examForm.classCode = this.transClassCode;
            this.examForm.teacherCode = this.transTeacherCode;
            this.examForm.searchType = this.transSearchType;
            this.userAuth = this.transUserAuth;
        },
        mounted() {
            this.searchTypeInfo = [{"comboValue":"1","comboName":"班级查询"},{"comboValue":"2","comboName":"教师查询"}];
            this.initParam();
        },
        methods: {
            initParam(){
                this.initBlankTimetable();
            },
            queryExamInfo() {
                this.timetableLoading = true;

                const paramMap = {
                    'xnxqbm': this.examForm.xnxqbm,
                    'kcapzbbh': this.examForm.kcapzbbh,
                    'examType': this.examForm.examType,
                    'classCode': this.examForm.classCode,
                    'teacherCode': this.examForm.teacherCode,
                    'searchType': this.examForm.searchType,
                    'userAuth': this.userAuth,
                }
                this.$api.examManage.examSearch.queryExamInfo({
                    data: paramMap,
                }).then((response) => {
                    this.timetableInfo = response.data.data.timetable.cellList;
                    this.parseTimetableInfo(this.timetableInfo);
                }).catch(error => {
                    console.log(error);
                });
            },
            parseTimetableInfo(timetableInfo) {
                const _this = this;

                timetableInfo.forEach((cell, index) => {
                    let tempCourseName = '';

                    if(this.examForm.examType=="4"){
                        if(this.userAuth=="8"){
                            if (cell.teaName != null) tempCourseName += cell.courseName + "<br/><br/>" + cell.siteName;
                        }else{
                            if (cell.teaName != null) tempCourseName += cell.teaName + "<br/><br/>" + cell.siteName;
                        }
                    }else{
                        if (cell.courseName != null) {
                            tempCourseName = cell.courseName;
                            if (cell.weekNum != null) tempCourseName += "<br/><br/>" + cell.teaName + "<br/><br/>" + cell.siteName;
                        }
                    }

                    document.getElementById('cell_' + index).innerHTML = tempCourseName;
                    _this.cellContent[index] = tempCourseName;
                });

                if (this.isApplyState) {
                    const courseArrangeInfo = this.getCourseArrnageInfo(this.applyForm.applyPlanCode);
                    this.handleCoursePositionStyle(courseArrangeInfo);
                }

                this.timetableLoading = false;
            },
            initBlankTimetable() {
                this.$api.examManage.examSearch.baseParam({
                    data: {
                        xnxqbm: this.examForm.xnxqbm,
                        kcapzbbh: this.examForm.kcapzbbh,
                    },
                }).then((res) => {
                    this.weekDayNum = parseInt(res.data.data.baseParam.weekDayNum, 10);
                    this.weekDayName = res.data.data.baseParam.weekDayName.split(',');
                    this.forenoonNum = parseInt(res.data.data.baseParam.forenoonNum, 10);
                    this.noonNum = parseInt(res.data.data.baseParam.noonNum, 10);
                    this.afternoonNum = parseInt(res.data.data.baseParam.afternoonNum, 10);
                    this.eveningNum = parseInt(res.data.data.baseParam.eveningNum, 10);
                    let totalnum = res.data.data.baseParam.totalNum;
                    const timeQuantumArray = res.data.data.baseParam.timeQuantum.split(',');
                    const _this = this;
                    this.timeQuantum = new Array();
                    timeQuantumArray.forEach(element => {
                        _this.timeQuantum.push(element);
                    });
                    this.cellContent = new Array(this.weekDayNum * parseInt(res.data.data.baseParam.totalNum,10));

                    if(totalnum<3){
                        this.timetdHeight = "160px";
                    }else{
                        this.timetdHeight = (window.innerHeight*0.6)/(parseInt(totalnum,10))+"px";
                    }

                    this.queryExamInfo();
                }).catch((err) => {
                    console.log(err);
                });
            },
            clearTimeTable(){
                if(this.timetableInfo != null){
                    this.timetableInfo.forEach((cell, index) => {
                        document.getElementById('cell_' + index).innerHTML = "";
                    });
                }
            },
            closeExamInfoDialog(){
                this.examInfoDialogVisible = false;
            },
        },
    };
</script>

<style scoped>
    .el-row {
        padding-bottom: 0px;
    }
    .searchButton{
        margin: auto;
        text-align: center;
    }
    .filter-container {
        padding-bottom: 10px;
    }
    .el-checkbox-button /deep/ .el-checkbox-button__inner {
        width: 70px;
        border-radius: 0;
    }
    .checkfooter {
        height:60px;
        margin-top:10px;
        padding-bottom:20px;
    }
    .examInfoDialog{

    }
    .examInfoDiv {
        heigh:60vh;
        white-space:pre-wrap;
    }
    .timetable {
        width: 100%;
        border-top: 1px solid #DCDFE6;
        border-left: 1px solid #DCDFE6;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: center;
    }

    .timetable td {
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        padding: 0;
    }

    .timetableTitle {
        background-color: #F1FAF6;
        font-weight: bold;
    }

    .cellsize{
        font-size:12px;
    }

    /* .separetor {
        border-bottom: 4px double #DCDFE6 !important;
    } */
</style>



// WEBPACK FOOTER //
// examTimeTableMobile.vue?4a3588b1